import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
type Props = {
  label: string;
  value: string;
  delta?: number;
  positiveIsGood?: boolean;
  accent?: boolean;
};
export function KpiCard({
  label,
  value,
  delta,
  positiveIsGood = true
}: Props) {
  const hasDelta = typeof delta === 'number' && delta !== 0;
  const good = positiveIsGood ? (delta ?? 0) > 0 : (delta ?? 0) < 0;
  const Icon = (delta ?? 0) > 0 ? TrendingUp : TrendingDown;
  return <div className="bg-[#181818] border border-[#262626] rounded-xl p-5 hover:border-[#333] transition-colors" data-id="element-774">
      <div className="text-xs text-[#9A9A9A] font-medium" data-id="element-775">{label}</div>
      <div className="mt-3 text-2xl font-semibold font-heading tracking-tight text-[#FAFAFA]" data-id="element-776">
        {value}
      </div>
    </div>;
}